var Tracker = require('../navigation/tracker');

module.exports = function(header) {
	var _t = this;
	var tracker = new Tracker();

	this.classList.add('expandable');
	this.selected = false;

	this.show = function() {
		this.selected = true;
		this.classList.add('selected');
		refresh();
		on(this, 'show').fire();
	}; // show();

	this.hide = function() {
		this.selected = false;
		this.classList.remove('selected');
		refresh();
		on(this, 'hide').fire();
	}; // hide()

	var refresh = function() {
		 _t.expandButton = _t.selected ? '[-]' : '[+]';
	};

	header.onclick = function() {
		if (_t.selected) {
			_t.hide();
		} else {
			_t.show();
		}
	};

	refresh();

};
